enum WorkspaceProjectCarbonRemovalStatus {
  draft = 'draft',
  active = 'active',
}

export default WorkspaceProjectCarbonRemovalStatus
